export class YesNoModalDialogModel {
    public constructor(
        public title: string,
        public message: string,
        public yesMessage: string,
        public noMessage = '',
        public cancelMessage = '',
        public showYes = true,
    ) {}
}
